import type { CompanyCostCategory } from './api/companyCostsApi';
import './companyCostCategory.css';

// Single home for the company-cost category identity colour. The palette is
// the `--cost-category-*` token set in App.css (light and dark); a marker
// takes the class and paints `var(--cost-category)`. Slots never move: a new
// category is appended to both App.css token sets and companyCostCategory.css.
export const categoryClass = (category: CompanyCostCategory): string => `cost-category--${category}`;
